<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage" button ></ion-back-button>
          <ion-title>My Reservation</ion-title>
          <ion-icon @click="openReservationCancel" v-if="reservation && reservation.status.id === 'O' && (userRoleId == 4 || userRoleId == 2)" v-slot: icon-only :icon="trash" class="ios-home"></ion-icon>
          <!-- <ion-button> -->
            <ion-icon :icon="homeSharp"  class="ion-margin ios-home" @click="homePage"></ion-icon>
          <!-- </ion-button> -->
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar class="app-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage" button></ion-back-button>
          <ion-title>
            My Reservation /
            <span
              class="ion-sub-title"
            >{{reservation ? reservation.refNo : ''}} | {{reservation ? changeDateFormatWithTime(reservation.slot.startsOn) : ''}}</span>
          </ion-title>
          <ion-buttons v-slot: end v-if="reservation && reservation.status.id === 'O' && (userRoleId == 4 || userRoleId == 2)">
            <ion-button @click="openReservationCancel" class="ios-cancel">
              CANCEL
            </ion-button>
          </ion-buttons>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="page">
        <ion-grid fixed v-if="reservation" class="rp-mobile">
          <ion-row
            v-if="reservation.status.id === 'O' || reservation.status.id === 'P' || reservation.status.id === 'C' || reservation.status.id === 'I'"
            class="row-divider"
          ></ion-row>
          <ion-row>
            <ion-col>
              <div class="qrcodeStream">
                <qrcode-stream v-if="isShowingCamera" @detect="onDetect"></qrcode-stream>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row
            v-if="(reservation.status.id === 'O' && reservation.isTimeForCharging && userRoleId != 4) || reservation.status.id === 'P' || reservation.status.id === 'C' || reservation.status.id === 'I'"
            class="rectangle"
          >
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="6" class="col-padding">
                  <ion-button
                    v-if="displayStartBtn && reservation.isTimeForCharging && userRoleId != 4"
                    class="btn-primary"
                    expand="block"
                    @click="startCharging"
                  >Start Charging</ion-button>
                </ion-col></ion-row>
              <ion-row>
                <ion-col size="6" class="col-padding">
                  <ion-button
                  v-if="reservation.status.id === 'P' || (viewAndStopBtn && disableStopBtn)"
                  class="btn-critical"
                  expand="block"
                  @click="stopChargingAlert"
                >Stop Charging</ion-button>
                </ion-col>
                <ion-col size="6" class="col-padding">
                  <ion-button
                    v-if="(reservation.status.id === 'P' || reservation.status.id === 'C' || reservation.status.id === 'I' || viewAndStopBtn)"
                    class="btn-secondary"
                    expand="block"
                    @click="viewCharging"
                  >View Status</ion-button>
                </ion-col>
              </ion-row>
            </ion-col>
            <ion-col  v-if="displayToggleBtn">
              <ion-list>
                <!-- <ion-item v-if="reservation.gun.setup.charger.sendDataTransfer != 'N'"> -->
                <ion-item>
                  <ion-label>Send OTP</ion-label>
                  <ion-toggle @ionChange="sendOtp(otpIsChecked)" :disabled="disableOtpToggle" v-bind:checked = otpIsChecked>
                  </ion-toggle>
                </ion-item>
                <ion-item>
                  <ion-label>{{isShowingCamera ? "Stop Scan" : "Scan QR Code"}}</ion-label>
                  <ion-toggle @ionChange="openCamera(QRIsChecked)"  :disabled="disableQRToggle" :checked = QRIsChecked>
                  </ion-toggle>
                </ion-item>
              </ion-list>
            </ion-col></ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle">
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="6" class="col-padding">
                  <span class="reservation-head">
                    <img
                      v-if="reservation.vehicle.type.id === 'TW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/335024.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'FW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/846338.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == '3W'"
                      class="vh-icon"
                      src="/assets/images/vehicles/rickshaw.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'BUS'"
                      class="vh-icon"
                      src="/assets/images/vehicles/bus.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'TRUCK'"
                      class="vh-icon"
                      src="/assets/images/vehicles/truck.png"
                    />
                    &nbsp;&nbsp;
                    {{reservation.vehicle.regNo}}
                  </span>
                   <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.vehicle.make.name}}&nbsp;{{reservation.vehicle.model.name}}</ion-label>
                  <br />
                  <ion-label class="reservation-desc">{{reservation.vehicle.socketType.name}}</ion-label>
                </ion-col>
                <ion-col size="6" class="col-padding ion-text-right"><ion-label class="book-time">
                    {{changeDateFormatWithTime(reservation.slot.startsOn)}}
                    <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
                    <!-- <br />
                    {{changeDateFormatWithTime(reservation.slot.endsOn)}} -->
                  </ion-label>
                  <br />
                  <ion-label
                    v-if="reservation.status.id !== 'C'"
                    class="reservation-desc"
                  >Reservation time</ion-label>
                  <ion-label v-else class="reservation-desc">Reservation time</ion-label>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle">
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="9" class="col-padding">
                  <ion-label class="book-station">{{reservation.station.name}}<span v-if="reservation.station.rating != 0">&nbsp;{{reservation.station.rating}}&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></ion-label>
                  <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.station.address.line1}}, {{reservation.station.address.city}}</ion-label>
                  <br />
                  <ion-label v-if="reservation.stationRating" class="rating-desc">
                    Your Rating :
                    <star-rating
                      v-bind:inline="true"
                      v-bind:read-only="true"
                      v-bind:rating="reservation.stationRating"
                      v-bind:show-rating="false"
                      v-bind:max-rating="5"
                      active-color="#21b24b"
                      v-bind:star-size="15"
                    ></star-rating>
                  </ion-label>
                  <br />
                  <br />
                  <ion-label class="section-desc">
                    {{reservation.station.address.line1}},
                    {{reservation.station.address.line2}}
                    <br />
                    {{reservation.station.address.line3}},
                    {{reservation.station.address.city}}
                    <br />
                    {{reservation.station.address.state.name}} -
                    {{reservation.station.address.zipcode}}
                  </ion-label>
                </ion-col>
                <ion-col
                  size="3"
                  class="col-padding ion-text-right"
                  v-if="reservation.status.id === 'O'"
                >
                  <a v-bind:href="'tel:' + reservation.station.mobile" class="call-img-a">
                    <img class="call-img" src="../../assets/card-call.png" />
                  </a>
                  <br /><br />
                  <img
                    class="map-img"
                    src="../../assets/card-map.png"
                    @click="googleMapApp(reservation.station.coordinate)"
                  />
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="6" class="col-padding ion-text-center"><ion-label class="section-head">Reservation Status :</ion-label> </ion-col>
            <ion-col size="6" class="col-padding ion-text-left">
              <ion-label
                v-if="reservation.status.id === 'NA'"
                class="book-amount"
              >&#8377; {{reservation.commercial.estimated.nettCost | currency}}</ion-label>
              <br v-if="reservation.status.id === 'NA'" />
              <ion-label
                :key="reservation.status.id"
                v-bind:class="statusClass"
              >{{reservation.status.name}}</ion-label></ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="section-head">Charger</ion-label>
              <br />
              <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
              <!-- <ion-label class="section-desc">Charger Type : {{getTitle(reservation.gun.title)}}</ion-label> -->
              <ion-label class="section-desc">Charger Type : {{(reservation.gun.titleGroup)}}</ion-label>
              <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
              <!-- <br />
              <ion-label class="section-desc">Charger Output : {{reservation.gun.subTitle}}</ion-label> -->
              <br />
              <ion-label class="section-desc">Charging Port : {{reservation.gun.detail}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="section-head">Reservation</ion-label>
              <br />
              <ion-label class="section-desc">Reservation # : {{reservation ? reservation.refNo : ''}}</ion-label>
              <br />
              <ion-label class="section-desc">Reservation Type : {{reservation.type.info.name}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'CB'"
                  class="section-desc"
                ><br />Battery capacity at the time of reservation : {{reservation.existingQuantity}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'AB' && parseInt(reservation.commercial.estimated.nettCost) != 0"
                  class="section-desc"
                ><br />Amount To Charge : &#8377;{{reservation.amountToCharge.toFixed(2)}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'UB'"
                  class="section-desc"
                ><br />Unit To Charge : {{reservation.unitToCharge.toFixed(3)}}</ion-label>
              <br />
              <ion-label class="section-desc">Bay Name/Connector :</ion-label>
              <ion-label class="status-medium-rc bay-connector">{{reservation.bayName}}</ion-label>-
              <ion-label class="status-medium-rc bay-connector">{{reservation.portName}}</ion-label>
              <br /></ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="4" class="col-padding">
              <ion-label class="section-head">Estimation Details</ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.startsOn)}}
              </ion-label>
              <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
              <!-- <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.endsOn)}}
              </ion-label> -->
              <br />
              <ion-label class="section-desc">
                <b>Estimated kWh :</b>
                {{reservation.commercial.estimated.unit.toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Usage Charge :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Distribution Charge :</b>
                &#8377;{{(reservation.commercial.estimated.distributionCharge ? reservation.commercial.estimated.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount % :</b>
                {{reservation.commercial.estimated.discountPercentage ? reservation.commercial.estimated.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount :</b>
                &#8377;{{(reservation.commercial.estimated.discountAmount ? reservation.commercial.estimated.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Taxable Amount :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Total Tax :</b>
                &#8377;{{reservation.commercial.estimated.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Invoice Total :</b>
                &#8377;{{reservation.commercial.estimated.nettCost.toFixed(2)}}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="row-divider"></ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="4" class="col-padding"><ion-label class="section-head">
                Invoice Details &nbsp;&nbsp;<ion-button class="btn-download" @click="downloadInvoice">
                  <ion-icon :icon="download"></ion-icon>&nbsp; Download
                </ion-button>
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.startsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.endsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Actual kWh :</b>
                {{(reservation.commercial.actual.unit ? reservation.commercial.actual.unit : 0).toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Usage Charge :</b>
                &#8377;{{reservation.commercial.actual.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Distribution Charge :</b>
                &#8377;{{(reservation.commercial.actual.distributionCharge ? reservation.commercial.actual.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount % :</b>
                {{reservation.commercial.actual.discountPercentage ? reservation.commercial.actual.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount :</b>
                &#8377;{{(reservation.commercial.actual.discountAmount ? reservation.commercial.actual.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Taxable Amount :</b>
                &#8377;{{reservation.commercial.actual.taxableAmount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Total Tax :</b>
                &#8377;{{reservation.commercial.actual.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Total :</b>
                &#8377;{{reservation.commercial.actual.nettCost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice No :</b>
                {{reservation.invoice.invoiceNo}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Date :</b>
                {{reservation.invoice.invoiceOn != null ? changeDateFormatWithDate(reservation.invoice.invoiceOn) : ""}}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="row-divider"></ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="section-head">Usage Details</ion-label>
              <br />
              <ion-row>
                <ion-col>
                  <ion-label class="section-head">ToU</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Usage</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Rs/kWh</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Charges</ion-label>
                </ion-col>
              </ion-row>
              <ion-row
                class="list-item"
                v-for="(invoiceTariff, index) in this.reservation.invoiceDetails"
                :key="index"
              >
                <ion-col class="section-desc">{{invoiceTariff.tariffTag}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.unitsConsumed.toFixed(3)}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.unitPrice.toFixed(2)}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.usageCost.toFixed(2)}}</ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <!-- <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding ion-text-right">
              <ion-label
                v-if="reservation.status.id === 'NA'"
                class="book-amount"
              >&#8377; {{reservation.commercial.estimated.nettCost | currency}}</ion-label>
              <br />
              <ion-label
                :key="reservation.status.id"
                v-bind:class="statusClass"
              >{{reservation.status.name}}</ion-label></ion-col>
          </ion-row> -->
        </ion-grid>
        <ion-grid fixed v-if="reservation" class="rp-desktop">
          <ion-row class="rectangle">
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="12" size-md="3" class="col-padding">
                  <ion-label class="book-station">{{reservation.station.name}}<span v-if="reservation.station.rating != 0">&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon>{{reservation.station.rating}}</span></ion-label>
                  <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.station.address.line1}}, {{reservation.station.address.city}}</ion-label>
                  <br />
                  <ion-label v-if="reservation.stationRating" class="rating-desc">
                    Your Rating :
                    <star-rating
                      v-bind:inline="true"
                      v-bind:read-only="true"
                      v-bind:rating="reservation.stationRating"
                      v-bind:show-rating="false"
                      v-bind:max-rating="5"
                      active-color="#21b24b"
                      v-bind:star-size="15"
                    ></star-rating>
                  </ion-label>
                  <br />
                  <br />

                  <ion-label class="section-desc">
                    {{reservation.station.address.line1}},
                    {{reservation.station.address.line2}}
                    <br />
                    {{reservation.station.address.line3}},
                    {{reservation.station.address.city}}
                    <br />

                    {{reservation.station.address.state.name}} -
                    {{reservation.station.address.zipcode}}
                  </ion-label>
                  <br />
                  <ion-row align-items-stretch>
                    <ion-col size="12" size-md="3" class="col-padding">
                      <a v-bind:href="'tel:' + reservation.station.mobile" class="call-img-a">
                        <img class="call-img" src="../../assets/card-call.png" />
                      </a>
                    </ion-col>
                    <ion-col size="12" size-md="3" class="col-padding">
                      <img
                        class="map-img"
                        src="../../assets/card-map.png"
                        @click="googleMapApp(reservation.station.coordinate)"
                      />
                    </ion-col>
                  </ion-row>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                  <span class="reservation-head">
                    <img
                      v-if="reservation.vehicle.type.id === 'TW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/335024.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'FW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/846338.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == '3W'"
                      class="vh-icon"
                      src="/assets/images/vehicles/rickshaw.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'BUS'"
                      class="vh-icon"
                      src="/assets/images/vehicles/bus.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'TRUCK'"
                      class="vh-icon"
                      src="/assets/images/vehicles/truck.png"
                    />
                    &nbsp;&nbsp;
                    {{reservation.vehicle.regNo}}
                  </span><br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.vehicle.make.name}}&nbsp;{{reservation.vehicle.model.name}}</ion-label>
                  <br />
                  <ion-label class="reservation-desc">{{reservation.vehicle.socketType.name}}</ion-label>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding"><ion-label class="book-time">
                    {{changeDateFormatWithTime(reservation.slot.startsOn)}}
                    <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
                    <!-- <br />
                    {{changeDateFormatWithTime(reservation.slot.endsOn)}} -->
                  </ion-label>
                  <br />
                  <ion-label
                    v-if="reservation.status.id !== 'C'"
                    class="reservation-desc"
                  >Reservation time</ion-label>
                  <ion-label v-else class="reservation-desc">Reservation time</ion-label>
                </ion-col>
                <ion-col
                  size="6"
                  size-md="3"
                  v-if="(reservation.status.id === 'O' && reservation.isTimeForCharging && userRoleId != 4) || reservation.status.id === 'P' || reservation.status.id === 'C' || reservation.status.id === 'I'"
                  class="col-padding"
                >
                  <span class="reservation-head"></span>
                  <ion-button
                    v-if="reservation.isTimeForCharging"
                    class="btn-primary"
                    expand="block"
                    @click="startChargingWithoutQR"
                    :disabled = startBtnInd
                  >Start Charging</ion-button>           
                  <ion-col size="3"
                    size-md="3"
                    v-if="(reservation.status.id === 'O' && reservation.isTimeForCharging) || reservation.status.id === 'P' || reservation.status.id === 'C' || reservation.status.id === 'I'"
                    class="col-padding">
                    <span class="reservation-head"></span>
                    <ion-button
                      v-if="reservation.status.id === 'P'"
                      class="btn-critical"
                      expand="block"
                      @click="stopChargingAlert"
                    >Stop Charging</ion-button>
                    <ion-button
                      v-if="reservation.status.id === 'P' || reservation.status.id === 'C' || reservation.status.id === 'I'"
                      class="btn-secondary"
                      expand="block"
                      @click="viewCharging"
                    >View Status</ion-button>
                  </ion-col>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="4" class="col-padding">
              <ion-label class="section-head">Charger</ion-label>
              <br />
              <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
              <!-- <ion-label class="section-desc">Charger Type : {{getTitle(reservation.gun.title)}}</ion-label> -->
              <ion-label class="section-desc">Charger Type : {{(reservation.gun.titleGroup)}}</ion-label>
              <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
              <!-- <br />
              <ion-label class="section-desc">Charger Output : {{reservation.gun.subTitle}}</ion-label> -->
              <br />
              <ion-label class="section-desc">Charging Port : {{reservation.gun.detail}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="4" class="col-padding">
              <ion-label class="section-head">Reservation</ion-label>
              <br />
              <ion-label class="section-desc">Reservation # : {{reservation ? reservation.refNo : ''}}</ion-label>
              <br />
              <ion-label class="section-desc">Reservation Type : {{reservation.type.info.name}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'CB'"
                  class="section-desc"
                ><br />Battery capacity at the time of reservation : {{reservation.existingQuantity}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'AB' && parseInt(reservation.commercial.estimated.nettCost) != 0"
                  class="section-desc"
                ><br />Amount To Charge : &#8377;{{reservation.amountToCharge.toFixed(2)}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'UB'"
                  class="section-desc"
                ><br />Unit To Charge : {{reservation.unitToCharge.toFixed(3)}}</ion-label>
              <br />
              <ion-label class="section-desc">Bay Name/Connector : </ion-label>
              <ion-label class="status-medium-rc bay-connector">{{reservation.bayName}}</ion-label>-
              <ion-label class="status-medium-rc bay-connector">{{reservation.portName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2" class="col-padding ion-text-right">
              <ion-label
                v-if="reservation.status.id === 'NA'"
                class="book-amount"
              >&#8377; {{reservation.commercial.estimated.nettCost | currency}}</ion-label>
              <br />
              <ion-label
                :key="reservation.status.id"
                v-bind:class="statusClass"
              >{{reservation.status.name}}</ion-label></ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="4" class="col-padding">
              <ion-label class="section-head">Estimation Details</ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.startsOn)}}
              </ion-label>
              <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
              <!-- <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.endsOn)}}
              </ion-label> -->
              <br />
              <ion-label class="section-desc">
                <b>Estimated kWh :</b>
                {{reservation.commercial.estimated.unit.toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Usage Charge :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Distribution Charge :</b>
                &#8377;{{(reservation.commercial.estimated.distributionCharge ? reservation.commercial.estimated.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount % :</b>
                {{reservation.commercial.estimated.discountPercentage ? reservation.commercial.estimated.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount :</b>
                &#8377;{{(reservation.commercial.estimated.discountAmount ? reservation.commercial.estimated.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Taxable Amount :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Total Tax :</b>
                &#8377;{{reservation.commercial.estimated.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Invoice Total :</b>
                &#8377;{{reservation.commercial.estimated.nettCost.toFixed(2)}}
              </ion-label>
            </ion-col>
            <ion-col v-if="reservation.status.id === 'C'" size="12" size-md="4" class="col-padding"><ion-label class="section-head">
                Invoice Details &nbsp;&nbsp;
                <ion-button class="btn-download" @click="downloadInvoice">
                  <ion-icon :icon="download"></ion-icon>&nbsp; Download
                </ion-button>
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.startsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.endsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Actual kWh :</b>
                {{(reservation.commercial.actual.unit ? reservation.commercial.actual.unit : 0).toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Usage Charge :</b>
                &#8377;{{reservation.commercial.actual.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Distribution Charge :</b>
                &#8377;{{(reservation.commercial.actual.distributionCharge ? reservation.commercial.actual.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount % :</b>
                {{reservation.commercial.actual.discountPercentage ? reservation.commercial.actual.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount :</b>
                &#8377;{{(reservation.commercial.actual.discountAmount ? reservation.commercial.actual.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Taxable Amount :</b>
                &#8377;{{reservation.commercial.actual.taxableAmount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Total Tax :</b>
                &#8377;{{reservation.commercial.actual.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Total :</b>
                &#8377;{{reservation.commercial.actual.nettCost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice No :</b>
                {{reservation.invoice.invoiceNo}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Date :</b>
                {{reservation.invoice.invoiceOn != null ? changeDateFormatWithDate(reservation.invoice.invoiceOn) : ""}}
              </ion-label>
            </ion-col>
            <ion-col v-if="reservation.status.id === 'C'" size="12" size-md="4" class="col-padding">
              <ion-label class="section-head">Usage Details</ion-label>
              <ion-row class="list-head">
                <ion-col size="12" size-md="3">
                  <ion-label class="section-head">ToU</ion-label>
                </ion-col>
                <ion-col class="numeric-desc" size="12" size-md="3">
                  <ion-label class="section-head">Usage</ion-label>
                </ion-col>
                <ion-col class="numeric-desc" size="12" size-md="3">
                  <ion-label class="section-head">Rs/kWh</ion-label>
                </ion-col>
                <ion-col class="numeric-desc" size="12" size-md="3">
                  <ion-label class="section-head">Charges</ion-label>
                </ion-col>
              </ion-row>
              <hr />
              <ion-row
                class="list-item"
                v-for="(invoiceTariff, index) in this.reservation.invoiceDetails"
                :key="index"
              >
                <ion-col size="12" size-md="3">
                  <ion-label class="section-desc">{{invoiceTariff.tariffTag}}</ion-label>
                </ion-col>
                <ion-col class="numeric-desc" size="12" size-md="3">
                  <ion-label class="numeric-desc">{{invoiceTariff.unitsConsumed.toFixed(3)}}</ion-label>
                </ion-col>
                <ion-col class="numeric-desc" size="12" size-md="3">
                  <ion-label class="numeric-desc">{{invoiceTariff.unitPrice.toFixed(2)}}</ion-label>
                </ion-col>
                <ion-col class="numeric-desc" size="12" size-md="3">
                  <ion-label class="numeric-desc">{{invoiceTariff.usageCost.toFixed(2)}}</ion-label>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
    <div v-if="showModal" class="overlay">
        <div class="box">
          <h4>{{ errorMessage }}</h4>

          <div class="neon-progress-container">
            <div
              class="neon-progress-fill"
              :style="{ width: progressWidth + '%' }"
            ></div>
          </div>

          <p>Charger status updating</p>
        </div>
      </div>  
    <!-- commented by sindhu, ion-loading not support for iOS -->
    <!-- <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div> -->
    <!-- <div>
    <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..."></ion-loading>
    </div> -->
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonIcon, IonButton, IonContent, IonGrid, IonRow, IonCol, IonList, IonItem, IonToggle, IonLabel, IonSpinner, modalController, alertController, IonLoading } from "@ionic/vue";
import { trash, star,download, homeSharp } from 'ionicons/icons';
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import ReservationCancellationModal from "./ReservationCancellationModal.vue";
import ReservationRatingModal from "./ReservationRatingModel.vue";
import { LocalStorage } from "../../data/localstorage";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import StarRating from "vue-star-rating";
import { flag, flash } from 'ionicons/icons';

import { AlertUtils } from "../../util/alert-utils";
import moment from 'moment';
import { QrcodeStream } from "vue-qrcode-reader";
import { loadingController } from "@ionic/vue";

export default defineComponent ({
  name: 'myReservationView',
  components: {
    IonHeader, 
    IonToolbar, 
    IonButtons, 
    IonBackButton, 
    IonTitle, 
    IonIcon, 
    IonButton, 
    IonContent, 
    IonGrid, 
    IonRow, 
    IonCol, 
    IonList, 
    IonItem, 
    IonToggle, 
    IonLabel, 
    IonSpinner,
    StarRating,
    modalController,
    QrcodeStream,
    IonLoading
  },
  
  data() {
    return {
      // isLoading: false,
      homeSharp,
      trash,
      download,
      star,
      viewmode: false,
      // loaderTab: false,
      bookingId: "New",
      reservation: null,
      viewStatusAndStopInd: false,
      isShowingCamera: false,
      displayStartBtn: true,
      disableOtpToggle: false,
      disableQRToggle: false,
      otpIsChecked: false,
      QRIsChecked: false,
      displayToggleBtn: false,
      value: 'https://example.com',
      size: 300,
      viewAndStopBtn: false,
      disableStopBtn: true,
      startBtnInd: false,
      userRoleId: "",
      timeOut: null,
      durationInSeconds: '',
      waitingTime : 100,
      showModal: false,
      timeoutId: null,
      countdown: 60,
      countdownInterval: null,
      progressWidth: 0,
      interval: null,
      currentStatus: [],
      errorMessage: "",
      displayContent: false,
      durationCount: 0,
      monitorStatusInd: true,
      toMonitorProgressbar: null,
      durationForApiCall: 10,
      durationForProgressBar : 60,
      errorCodeList: [],
      loading: ""
    };
  },

  async mounted() {
    let countForDuration = await new EVCStationReservationService().getDisplayDuration();
    this.descriptionToConfirm = countForDuration.data.additionalinfo;
    this.durationCount = parseInt(countForDuration.data.description)

    let progressBarDuration = await new EVCStationReservationService().getProgressBarDuration();
    this.durationForProgressBar = parseInt(progressBarDuration.data.description)

    let apiCallRequestDuration = await new EVCStationReservationService().getDurationForApiCall();
    this.durationForApiCall = parseInt(apiCallRequestDuration.data.description);
      
    // commented by sindhu, ion-loading not support for iOS
    // this.isLoading = true;

    // Add this code by sindhu, instead of ion-loading support for iOS
    this.loading = await loadingController.create({
      message: 'Please Wait...',
      spinner: 'lines-sharp'
    })

    await this.loading.present();
    
    // this.loaderTab = true;
    this.displayStartBtn = true;

    this.durationInSeconds = await new EVCStationReservationService().getReloadDuration()

    // this.timeOut = setTimeout(() => {
    //   if(this.reservation.status.id === "X") {
    //     alert("Every 30 seconds");
    //   }
    // }, 30000)

    if (this.$route.params.bookingId) {
      if (this.$route.query.mode) {
        this.viewmode = false;
        this.bookingId = "Edit";
      } else {
        this.viewmode = true;
        this.bookingId = this.$route.params.bookingId;
        await this.getBooking();
        if(this.reservation != null) {
          if (
            (this.reservation.status.id === "C" || this.reservation.status.id === 'I') &&
            this.reservation.stationRating == null
          ) {
            await this.loading.dismiss();
            this.openFeedbackModal(this.reservation);
          } else if(this.reservation.status.id === "P") {
            //  this.isLoading = false;
            await this.loading.dismiss();
            // this.loaderTab = false;
            this.timeOut = setTimeout(() => {
            this.$router.go()
          }, this.durationInSeconds.description)

          window.addEventListener("beforeunload", this.clearMyTimeout);

          }else {
            // this.isLoading = false;
            await this.loading.dismiss();
          }
        }
        
      }
    }
    
    // this.isLoading = false;
    // this.loaderTab = false;
    this.userRoleId = localStorage.getItem('user.roleId');
    
  },
  unmounted() {
    try {
      if (this.interval) {
        clearInterval(this.interval)
      }
      if (this.toMonitorProgressbar) {
        clearInterval(this.toMonitorProgressbar)
      }
      this.showModal = false
    } catch(error) {
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
  },
  ionViewWillLeave() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    if (this.toMonitorProgressbar) {
      clearInterval(this.toMonitorProgressbar)
    }
    this.showModal = false
  },
  beforeUnmount() {
    this.clearMyTimeout();
    window.removeEventListener("beforeunload", this.clearMyTimeout);
  },

  computed: {
    statusClass() {
      var status = 'open';
      if (this.reservation.status.id === 'O') {
        status = 'open';
      } else if (this.reservation.status.id === 'X') {
        status = 'cancelled';
      } else if (this.reservation.status.id === 'P') {
        status = 'wip';
      } else if (this.reservation.status.id === 'I') {
        status = 'ierr';
      } else if (this.reservation.status.id === 'E') {
        status = 'expired';
      } else if (this.reservation.status.id === 'C') {
        status = 'completed';
      } else {
        status = 'open';
      }
      return 'status-medium-rc ' + status;
    }
    
  },
  
  methods: {
    clearMyTimeout() {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
        this.timeOut = null;
        // alert("Timeout cleared before unload");
      }
    },
  
    homePage() {
      let userRole = localStorage.getItem("user.roleId")
      if(userRole == 2) {
        this.$router.push("/customer/reservation")
      }
    },
    changeDateFormatWithDate(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY')
    },
    changeDateFormatWithTime(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    getTitle(title) {
      let secondaryTitle = title.split(",")[0];
      return secondaryTitle;
    },
    async onDetect (decodedString) {
      // this.loaderTab = true;
      // this.isLoading = true;
       this.loading = await loadingController.create({ 
        message: 'Please Wait...',
        spinner: 'lines-sharp'
      });

      await this.loading.present();
      if(decodedString) {
        this.isShowingCamera = !this.isShowingCamera;
        await new EVCStationReservationService().verifyOtpForStartCharging(
          decodedString[0].rawValue,
          { id: this.$route.params.bookingId },
          new LocalStorage().user
        ).then(async() => {
          localStorage.setItem("verifystart", "true");
          this.viewAndStopBtn = true;
          this.displayToggleBtn = !this.displayToggleBtn;
          await this.loading.dismiss();
          // this.loaderTab = false;
          // this.isLoading = false;
        }).catch(async (err) => {
          // let serviceError = tryParseServiceError(err);
          // new AlertUtils().presentAlert(
          //   serviceError ? serviceError : error
          // );
          // new ToastUtils().presentToast(serviceError ? serviceError : err);
          // new ToastUtils().presentToast(err.response.data.errors[0].detail);
          let serviceError = migratedTryParseServiceError(err);
          // new ToastUtils().presentToast(serviceError.description);
          if(serviceError.code == 'US1003' || serviceError.code == 'US1004' || serviceError.code == 'US1006') {
            if(this.monitorStatusInd) {
              this.monitorStatusInd = false;
              await this.startProgress(serviceError.description)
            }
          } else {
            await new ToastUtils().presentToast(serviceError.description);
          }
          this.displayToggleBtn = !this.displayToggleBtn;
          this.displayStartBtn = !this.displayStartBtn;
          this.disableOtpToggle = !this.disableOtpToggle;
          this.disableQRToggle = false;
          this.QRIsChecked = !this.QRIsChecked;
          // this.loaderTab = false;
          // this.isLoading = false;
          await this.loading.dismiss();
        });
      }
    },
    async openCamera(QrOrOtp) {
      this.loading = await loadingController.create({
          message: 'Please Wait...',
          spinner: 'lines-sharp'
        })
        // this.loaderTab = true;
        // this.isLoading = true;
      // this.loaderTab = true;
      // this.isLoading = true;
      await this.loading.present();
      this.getBooking().then(async() => {
        await this.loading.dismiss();
        if(this.reservation.status.id === 'P'){
          this.displayToggleBtn = false;
        } else {
          if(!this.QRIsChecked) {
          this.disableOtpToggle = !this.disableOtpToggle;
          this.isShowingCamera = !this.isShowingCamera;
          this.QRIsChecked = true;
          // this.loaderTab = false;
          // this.isLoading = false;
          new ToastUtils().presentToast(
            "Ready to start qr code"
          );
          } else {
            this.QRIsChecked = !this.QRIsChecked;
            this.disableOtpToggle = !this.disableOtpToggle;
            this.isShowingCamera = !this.isShowingCamera;
            // this.loaderTab = false;
            // this.isLoading = false;
          }
        }
      })
    },
    async sendOtp(val) {
      // this.isLoading = true;
      // this.loaderTab = true;
        this.getBooking().then(() => {
        if(this.reservation.status.id === 'P'){
          this.displayToggleBtn = false;
        } else {
          if(!this.otpIsChecked) {
            this.disableQRToggle = !this.disableQRToggle;
            this.otpIsChecked = !this.otpIsChecked;
            // this.loaderTab = true;
            // this.isLoading = true;
            try {
            
              new EVCStationReservationService().startChargingReservationByUser(
                { id: this.$route.params.bookingId },
                new LocalStorage().user
              ).then((data) => {
                // this.loaderTab = false;
                // this.isLoading = false;
                if(this.reservation.gun.setup.charger.sendDataTransfer != 'N') {
                  // below code is commented on 09-05-2025, OTP is sent to user for all charge box
                  // new ToastUtils().presentToast(
                  //   "Please check the Charger Control Panel for OTP"
                  // );
                  new ToastUtils().presentToast(
                    "OTP sent to your mobile number"
                  );
                } else {
                  new ToastUtils().presentToast(
                    "OTP sent to your mobile number"
                  );
                }
                
                // this.loaderTab = false;
                // this.isLoading = false;
                this.$router.push({
                  name: "verifyStartCharging",
                  params: { bookingId: this.$route.params.bookingId },
                });
            }).catch((err) => {
              // let serviceError = tryParseServiceError(err);
              // new ToastUtils().presentToast(serviceError ? serviceError : err);
              // new ToastUtils().presentToast(err.response.data.errors[0].detail);
              let serviceError = migratedTryParseServiceError(err);
              new ToastUtils().presentToast(serviceError.description);
              this.displayStartBtn = !this.displayStartBtn;
              this.displayToggleBtn = !this.displayToggleBtn;
              this.disableOtpToggle = false;
              this.disableQRToggle = false;
              this.otpIsChecked = false;
              // this.loaderTab = false;
              // this.isLoading = false;
            });
            
          } catch (error) {
            // let serviceError = tryParseServiceError(error);
            // new ToastUtils().presentToast(serviceError ? serviceError : error);
            // new ToastUtils().presentToast(error.response.data.errors[0].detail);
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
            this.displayStartBtn = !this.displayStartBtn;
              this.displayToggleBtn = !this.displayToggleBtn;
              this.disableOtpToggle = false;
              this.disableQRToggle = false;
              this.otpIsChecked = false;
              // this.loaderTab = false;
              // this.isLoading = false;
          }
          
          } else {
            this.disableQRToggle = !this.disableQRToggle;
            this.otpIsChecked = !this.otpIsChecked;
            // this.loaderTab = false;
            // this.isLoading = false;
          }
        }
      })
    },
    doRefresh(val) {
      setTimeout(() => {
        // console.log('Async operation has ended');
        val.target.complete();
      }, 2000);
    },
    googleMapApp(coordinate) {
      if (
        /* if we're on iOS, open in Apple Maps */
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPod") != -1 ||
        navigator.platform.indexOf("iPad") != -1
      )
        window.open(
          "maps://maps.google.com/maps?daddr=" +
            coordinate.latitude +
            "," +
            coordinate.longitude +
            "&amp;ll="
        );
      /* else use Google */ else
        window.open(
          "https://maps.google.com/maps?daddr=" +
            coordinate.latitude +
            "," +
            coordinate.longitude +
            "&amp;ll="
        );
    },
    async getBooking() {
      try {
        
        // this.loaderTab = true;
        // this.isLoading = true;
        this.reservation = await new EVCStationReservationService().reservationWithIdOfUser(
          this.$route.params.bookingId,
          new LocalStorage().user
        );
        // this.loaderTab = false;
        // this.isLoading = false;
      } catch(error) {
        // this.loaderTab = false;
        // this.isLoading = false;
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    editBooking() {
      localStorage.removeItem("slotDetails");
      localStorage.setItem(
        "editReservationDetails",
        JSON.stringify(this.reservation)
      );
      localStorage.setItem("editReservationPage", true);
      this.$router.push({
        name: "slotBooking",
      });
    },
    async openFeedbackModal(reservation) {
      // const modal = await this.$ionic.modalController.create({
      const modal = await modalController.create({
        component: ReservationRatingModal,
        componentProps: {
          data: {
            content: "New Content",
          },
          propsData: {
            title: "Rate our Station",
            reservation: reservation,
          },
          methods: {
            rateReservationStation(rating) {
              modal.dismiss({ rating: rating });
            },
            dismissDialog() {
              modal.dismiss({ rating: 5 });
            },
          },
        },
        cssClass: "my-custom-class",
      });
      modal.componentProps =  {title: "Rate Our Station", reservation: reservation };
      modal.onDidDismiss().then((data) => {
        if(data.role != 'backdrop') {
          if(data.data != null) {
              this.rateStation(data.data);
          }
        } else {
          this.rateStation(0);
        }

        // if (data && data.data) {
        //   this.rateStation(data["data"].rating);
        // } else {
        //   this.rateStation(0);
        // }
      });
      return await modal.present();
    },
    async openReservationCancel() {
      try {
        const modals = await modalController.create({
          component: ReservationCancellationModal,
          componentProps: {
          data: {
            content: "New Content",
          },
          propsData: {
            title: "Cancel Reservation",
            bookingId: this.$route.params.bookingId,
          },
          methods: {
            cancelBooking(reason, otherReason) {
              modals.dismiss({ id: reason, others: otherReason });
            },
            dismissDialog() {
              modals.dismiss();
            },
          },
        },
        cssClass: "my-custom-class",
        });
        modals.componentProps =  {title: "Cancel Reservation", bookingId: this.$route.params.bookingId};
        modals.cssClass = "my-custom-class"

      //   const modal = await this.$ionic.modalController.create({
      //   component: ReservationCancellationModal,
      //   componentProps: {
      //     data: {
      //       content: "New Content",
      //     },
      //     propsData: {
      //       title: "Cancel Reservation",
      //       bookingId: this.$route.params.bookingId,
      //     },
      //     methods: {
      //       cancelBooking(reason, otherReason) {
      //         modal.dismiss({ id: reason, others: otherReason });
      //       },
      //       dismissDialog() {
      //         modal.dismiss();
      //       },
      //     },
      //   },
      //   cssClass: "my-custom-class",
      // });
      modals.onDidDismiss().then((data) => {
        if(data.role != 'backdrop' && data.role !=undefined ) {
            if(data.data != '') {
              let res = { id: data.data, others: data.role }
              if(Object.keys(res).length > 0) {
                this.cancelBooking(res);
              }
            }
          }
        // var reason = data["data"]; // Here's your selected data!
        // if (reason) {
        //   this.cancelBooking(reason);
        // }
      });
      return await modals.present();
      } catch(error) {
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    async cancelBookingAlert() {
      return alertController.create({
        header: 'Cancel Reservation?',
        message: "Are you sure you want to cancel this Reservation?",
        buttons: [
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
            handler: res =>{

            }
          },
          {
            text: "YES",
            handler: () => {
              this.cancelBooking();
            },
          }

        ]
      }).then(res => res.present());

      //SCMT 2.O migration
      // const alert = document.createElement("ion-alert");
      // alert.header = "Cancel Reservation?";
      // alert.message = "Are you sure you want to cancel this Reservation?";
      // alert.buttons = [
      //   {
      //     text: "NO",
      //     role: "cancel",
      //     cssClass: "secondary",
      //     handler: () => {
      //       console.log("Confirm Cancel");
      //     },
      //   },
      //   {
      //     text: "YES",
      //     handler: () => {
      //       this.cancelBooking();
      //     },
      //   },
      // ];

      // document.body.appendChild(alert);
      // return alert.present();
    },
    async rateStation(rating) {
      try {
        await new EVCStationReservationService().rateReservationStation(
          { id: this.$route.params.bookingId },
          new LocalStorage().user,
          rating
        );
        await this.getBooking();
      } catch (error) {
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    async cancelBooking(reason) {
      try {
        var cancelReservation = await new EVCStationReservationService().cancelReservationForUser(
          { id: this.$route.params.bookingId },
          new LocalStorage().user,
          reason
        );
        
        var userRole = localStorage.getItem('user.roleId');
        if(userRole == 4) {
          let otpDetails = {
            otpType: "CancelRes",
            otpRefenrenceParamter: "ReservationId",
            otpReferenceParameterValue: this.$route.params.bookingId
          }
          let otpInfo = { bookingId: this.$route.params.bookingId, otpReason: cancelReservation, otpDetails: otpDetails }
          localStorage.setItem("otpInfo", JSON.stringify(otpInfo))
          this.$router.push({
            name: "globalOTPVerification",
            params: { bookingId: this.$route.params.bookingId, otpReason: cancelReservation, otpDetails: otpDetails },
          });
        } else {
          this.getBooking();
          new ToastUtils().presentToast("Reservation cancelled successfully");
        } 
      } catch (error) {
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    async startCharging() {
      try {
        // this.isLoading = true;
        await this.getBooking();
        this.getChargerStatus()
        // if(this.reservation.status.id !== 'P') {
        //   this.displayStartBtn = !this.displayStartBtn;
        //   this.displayToggleBtn = !this.displayToggleBtn;
        // }
        // this.isLoading = false; 
      } catch(error) {
        // this.isLoading = false;
        console.log(error);
      }

      // try {
      //   this.loaderTab = true;
      //   await new EVCStationReservationService().startChargingReservationByUser(
      //     { id: this.$route.params.bookingId },
      //     new LocalStorage().user
      //   );
      //   new ToastUtils().presentToast(
      //     "Please check the Charger Control Panel for OTP"
      //   );
      //   this.$router.push({
      //     name: "verifyStartCharging",
      //     params: { bookingId: this.$route.params.bookingId },
      //   });
      // } catch (error) {
      //   let serviceError = tryParseServiceError(error);
      //   new ToastUtils().presentToast(serviceError ? serviceError : error);
      // }
      // this.loaderTab = false;
    },

    async startChargingWithoutQR() {

      this.startBtnInd = true;
      this.isLoading = true;
      try {
        
        await this.getBooking();
        // this.loaderTab = true;
        // this.isLoading = true;
        if(this.reservation.status.id != 'P') {
          await new EVCStationReservationService().startChargingReservationByUser(
            { id: this.$route.params.bookingId },
            new LocalStorage().user
          );
          localStorage.setItem("dataTransfer", this.reservation.gun.setup.charger.sendDataTransfer)
          if(this.reservation.gun.setup.charger.sendDataTransfer != 'N') {
            // below code is commented on 09-05-2025, OTP is sent to user for all charge box
            // new ToastUtils().presentToast(
            //   "Please check the Charger Control Panel for OTP"
            // );
            new ToastUtils().presentToast(
              "OTP sent to your mobile number"
            );
          } else {
            new ToastUtils().presentToast(
              "OTP sent to your mobile number"
            );
          }
          // this.loaderTab = false;
          // this.isLoading = false;
          this.$router.push({
            name: "verifyStartCharging",
            params: { bookingId: this.$route.params.bookingId },
          });
        }
      } catch (error) {
        // this.isLoading = false;
        // this.loaderTab = false;
        // this.startBtnInd = false;
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      // this.loaderTab = false;
      // this.isLoading = false;
    },
    async stopChargingAlert() {
      return alertController.create({
        header: 'Stop Charging?',
        message: "Are you sure you want to Stop this Charging?",
        buttons: [
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
            handler: res =>{

            }
          },
          {
            text: "YES",
            handler: () => {
              this.stopCharging();
            },
          }

        ]
      }).then(res => res.present());

      // SCMT 2.O Migration
      // const alert = document.createElement("ion-alert");
      // alert.header = "Stop Charging?";
      // alert.message = "Are you sure you want to Stop this Charging?";
      // alert.buttons = [
      //   {
      //     text: "NO",
      //     role: "cancel",
      //     cssClass: "secondary",
      //     handler: () => {
      //       console.log("Confirm Cancel");
      //     },
      //   },
      //   {
      //     text: "YES",
      //     handler: () => {
      //       this.stopCharging();
      //     },
      //   },
      // ];

      // document.body.appendChild(alert);
      // return alert.present();
    },
    async stopCharging() {
      try {
        // this.isLoading = true;
        // this.loaderTab = true;
        this.loading = await loadingController.create({
          message: 'Please Wait...',
          spinner: 'lines-sharp'
        })

        await this.loading.present();
        await new EVCStationReservationService().stopChargingReservationByUser(
          { id: this.$route.params.bookingId },
          new LocalStorage().user
        );
        this.disableStopBtn = false;
        new ToastUtils().presentToast("Charging stopped successfully");
        this.getBooking();
        // this.isLoading = false;
        await this.loading.dismiss();
      } catch (error) {
        await this.loading.dismiss();
        // this.isLoading = false;
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      // this.loaderTab = false;
    },
    viewCharging() {
      localStorage.setItem('reservationTypeInfo', JSON.stringify(this.reservation.type))
      this.$router.push({
        name: "chargingStatusView",
        params: { bookingId: this.$route.params.bookingId },
      });
    },
    downloadInvoice() {
      const URL = new EVCStationReservationService().getDownloadURL(
        this.$route.params.bookingId,
        this.reservation.secretCode,
        new LocalStorage().user
      );
      // download(URL);
      // window.open(encodeURI(URL),"_system","location=yes");
      /*
      new EVCStationReservationService()
        .downloadInvoiceWithIdOfUser(
          this.$route.params.bookingId,
          this.reservation.secretCode,
          new LocalStorage().user
        )
        .then((response) => {
          const content = response.headers["content-type"];
          //console.log(response.headers["content-type"]);

          const URL = "http://localhost:8888/accounts/" + new LocalStorage().user.id + "/reservations/" + this.$route.params.bookingId + "/download/" + this.reservation.secretCode;
          //console.log(URL);
          download(URL, 'something.pdf');

          //blob
          // var url = window.URL.createObjectURL(new Blob([response.data]));
          // var a = document.createElement("a");

          // a.href = url;
          // a.setAttribute("download", "revc_invoice.pdf");
          // document.body.appendChild(a);

          // a.click();
          // a.remove();
        });*/

      var a = document.createElement("a");
      a.href = URL;
      a.setAttribute("download", "revc_invoice.pdf");
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    goBack() {
      var vehicleId = localStorage.getItem("myevid");
      if (vehicleId && vehicleId != null) {
        localStorage.removeItem("myevid");
        this.$router.replace({
          name: "eVehicleView",
          params: { vehicleId: Number(vehicleId) }
        });
      } else {
        this.$router.go(-0);
      }
    },
    openQRcode() {
      
    },
    async getChargerStatus() {
      try {
        let installationId = this.reservation.gun.setup.id
          this.currentStatus = await new EVCStationReservationService().getCurrentChargerStatus({installationId:installationId});
          this.displayContent = true;
          if(this.reservation.status.id !== 'P') {
            this.displayStartBtn = !this.displayStartBtn;
            this.displayToggleBtn = !this.displayToggleBtn;
          }
          this.monitorStatusInd = true;
          await this.startProgress("")
        } catch(error) {
          this.displayContent = false;
          let serviceError = migratedTryParseServiceError(error);
          this.errorCodeList = await new EVCStationReservationService().getErrorCodeList(serviceError.code);
          if(this.errorCodeList) {
            if(this.monitorStatusInd) {
              this.monitorStatusInd = false;
              await this.startProgress(serviceError.description)
            }
          } else {
            await new ToastUtils().presentToast(serviceError.description);
          }
        }
    },
    async startProgress(errorMessage) {
      this.errorMessage = errorMessage;
      this.showModal = true
      this.countdown = this.durationForProgressBar ;
      this.progressWidth = 0
      if(!this.monitorStatusInd) {
        this.interval = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--
            this.progressWidth = ((this.durationForProgressBar - this.countdown) / this.durationForProgressBar) * 100
          } 
          else {
            this.monitorStatusInd = true;
            clearInterval(this.interval)
            clearInterval(this.toMonitorProgressbar);
            this.closeModal()
          }
        }, 1000);
        this.toMonitorProgressbar = setInterval(() => {
          this.getChargerStatus();
        }, this.durationForApiCall)
      } else {
        this.monitorStatusInd = true;
        clearInterval(this.interval);
        clearInterval(this.toMonitorProgressbar);
        this.closeModal()
      }
    },
    async closeModal() {
      const modal = this.$refs.confirmModal

      if (modal && modal.$el) {
        await modal.$el.dismiss()
      }

      this.showModal = false
    },
  },
})
</script>

<style scoped>
.neon-progress-container {
  width: 80%;
  height: 20px;
  border-radius: 50px;
  border: 2px solid #21b24b;
  padding: 3px;
  margin: 0 auto;
  /* box-shadow: 0 0 15px #00fff7; */
  background: transparent;
}

.neon-progress-fill {
  height: 100%;
  width: 0%;
  border-radius: 50px;
  background: #21b24b;
  /* box-shadow: 0 0 20px #00fff7; */
  transition: width 1s linear;
}
.overlay {
  position: fixed;
  inset: 0;                     /* top:0 right:0 bottom:0 left:0 */
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 99999;               /* 🔥 very important */
}
.box {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 80%;
  max-width: 350px;
  text-align: center;
}
.ios .ios-home {
  color: white;
  position: relative;
  left: 60%;
  margin: 10px;
}

.ios .ios-cancel{
  position: relative;
  left: 500%;
  margin: 10px;
}

ion-icon {
  color: white;
}
.vh-icon {
  height: 17px;
  width: 33px;
  vertical-align: middle;
  display: inline-block;
  clear: left;
}
.rating-desc {
  text-align: left;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  white-space: nowrap !important;
}
.section-desc {
  text-align: left;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.section-answer {
  text-align: right;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.book-amount {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 15px;
  color: #21b24b;
  opacity: 1;
}
.book-day {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}
.book-time {
  text-align: right;
  font-family: "Roboto";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}
.book-station {
  text-align: left;
  font-family: "Roboto Bold";
  font-size: 14px;
  letter-spacing: 0;
  color: #21315d;
  opacity: 1;
}
.reservation-head {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.reservation-desc {
  text-align: left;
  font-family: "Roboto";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 0.5;
}
.station-distance {
  margin: 0px 0px 20px 20px;
  text-align: left;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #d66c6c;
  opacity: 1;
}
img.call-img {
  width: 24px;
  height: 24px;
  top: -3px;
}
img.map-img {
  width: 36px;
  height: 36px;
  cursor: pointer;
}

.qrcodeStream {
  width: 80%;
  margin: 0 auto;
  border-left: 5px solid #21b24b;
  border-right: 5px solid #21b24b;
  border-radius: 10px;
}
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-button {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}

.numeric-desc {
  text-align: right !important;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.my-custom-class {
  background-color: #222;
  width: 50% !important;
}

ion-modal {
 --width: 80% !important; 
 --hight: 80% !important;
}

.my-custom-class {
 --width: 80% !important; 
 --hight: 80% !important;

}
</style>